import { useState } from "react";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import "./DateRangeComponent.css";
import { useOnClickOutsideTwo } from "../../../utils/useClickOutside";
import {
  RazorButton,
  RazorInputField,
  RazorNumberFormat,
} from "../../razor-reuse";

interface MyComponentProps {
  value?: string;
  onSet?: (param?: any) => void;
  onCancel?: () => void;
}

const AmountRangeComponent = ({ value, onSet, onCancel }: MyComponentProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  //   const [startDate, setStartDate] = useState("");
  //   const [endDate, setEndDate] = useState("");
  type detailProps = {
    minValue: string;
    maxValue: string;
  };
  const [details, setDetails] = useState<detailProps>({
    maxValue: "",
    minValue: "",
  });

  const dropDownRRef = useOnClickOutsideTwo(() => {
    setShowModal(false);
  });

  const handleFinish = () => {
    // e && e.stopPropagation();
    const val = `${RazorNumberFormat(details?.minValue, {
      convertToNumber: true,
    })},${RazorNumberFormat(details?.maxValue, { convertToNumber: true })}`;
    onSet && onSet(val);
    setShowModal(false);
  };

  const handleCancel = () => {
    setDetails({
      maxValue: "",
      minValue: "",
    });
    onCancel && onCancel();
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  return (
    <>
      <div
        //   ref={dropDownRRef}
        className="date-range-index-wrapper-box"
      >
        {/* click component start */}
        <div
          onClick={() => {
            setShowModal(!showModal);
          }}
          className="date-range-click-box"
        >
          <div className="img-value-box">
            {/* <div className="img-wrap">
              <figure className="img-box">{ALL_ICONS?.calendar_icon}</figure>
            </div> */}
            <p className="value">{value || `Amount Range`}</p>
            {!value && (
              <div className="drop-icon">
                <figure className="img-box">{ALL_ICONS?.down_chevron}</figure>
              </div>
            )}
          </div>
          {/* cancel here start */}
          {value && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleCancel();
              }}
              className="cancel-box"
            >
              <figure className="img-box">{ALL_ICONS?.close_modal}</figure>
            </div>
          )}
          {/* cancel here end */}
        </div>
        {/* click component end */}
        {/* drop here start */}
        {showModal && (
          <div
            // onClick={() => {
            //   setShowModal(true);
            // }}
            className="drop-box-wrapper"
          >
            <div className="title-text-box">
              <p className="title">Amount Range</p>
              <p className="text">
                Enter the minimum amount and maximum amount <br /> for your
                transcations
              </p>
            </div>
            {/* form part start */}
            <div className="form-part">
              <RazorInputField
                color="black-light"
                type="number"
                label="Minimum Amt"
                placeholder=" Enter minimum amount"
                onChange={handleChange}
                value={details?.minValue}
                name={`minValue`}
                thousandFormat
              />
              <RazorInputField
                color="black-light"
                type="number"
                // label="End Date"
                label="Maximum Amt"
                placeholder=" Enter maximum amount"
                onChange={handleChange}
                value={details?.maxValue}
                name={`maxValue`}
                thousandFormat
              />

              <RazorButton
                disabled={!details?.minValue || !details?.maxValue}
                color="black-light"
                label="Apply"
                className="btn"
                onClick={handleFinish}
              />
            </div>
            {/* form part end */}
          </div>
        )}
        {/* drop here end */}
      </div>
      {/* modal here start */}
      {/* modal here end */}
    </>
  );
};

export default AmountRangeComponent;
